import styled from "styled-components";
import { gridGutters } from "../../styles/grid";

export const Code = styled.pre`
    padding: ${gridGutters(1)};

    font-size: ${(p) => p.theme.fontSize[0]};
    font-family: monospace;
`;
